<div class="min-h-screen bg-[#F8FAFC] pb-24 text-gray-800 font-sans">
    <!-- ========================================== -->
    <!-- 1. VOUCHER HERO SECTION (Shopee-like Vibe) -->
    <!-- ========================================== -->
    <section
        class="relative bg-gradient-to-b from-[#102B51] via-[#163564] to-[#0D2240] text-white py-14 md:py-20 overflow-hidden">
        <!-- Ambient Glows -->
        <div class="absolute -top-24 -left-24 w-96 h-96 bg-emerald-500/20 rounded-full blur-3xl pointer-events-none">
        </div>
        <div class="absolute top-1/2 -right-24 w-96 h-96 bg-amber-500/15 rounded-full blur-3xl pointer-events-none">
        </div>

        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
            <div class="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
                <!-- Left: Title & Subtitle -->
                <div class="lg:col-span-7 space-y-5 text-center lg:text-left">
                    <!-- Main Heading -->
                    <h1
                        class="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight text-white leading-tight">
                        Klaim Voucher Hemat <br class="hidden sm:block">
                        <span
                            class="text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 via-teal-300 to-amber-300">
                            Hingga 30% OFF
                        </span>
                    </h1>

                    <!-- Description -->
                    <p class="text-gray-300 text-sm md:text-base lg:text-lg leading-relaxed max-w-2xl mx-auto lg:mx-0">
                        Dapatkan potongan harga spesial untuk paket Photobooth, Videobooth 360, Undangan Digital,
                        Digital Guestbook, dan Smart Ticketing. Klaim sekarang sebelum kuota habis!
                    </p>

                    <!-- Quick Stats / Badges -->
                    <div
                        class="pt-2 flex flex-wrap items-center justify-center lg:justify-start gap-4 text-xs md:text-sm text-gray-200">
                        <div
                            class="flex items-center gap-2 bg-white/10 px-3.5 py-2 rounded-xl border border-white/10 backdrop-blur-sm">
                            <span>100% Promo Resmi</span>
                        </div>
                        <div
                            class="flex items-center gap-2 bg-white/10 px-3.5 py-2 rounded-xl border border-white/10 backdrop-blur-sm">
                            <span>Bisa Langsung Dipakai</span>
                        </div>
                        <div
                            class="flex items-center gap-2 bg-white/10 px-3.5 py-2 rounded-xl border border-white/10 backdrop-blur-sm">
                            <span>Validasi Otomatis</span>
                        </div>
                    </div>
                </div>

                <!-- Right: Featured Promo Banner -->
                <div *ngIf="promoBannerUrl" class="lg:col-span-5 flex justify-center">
                    <div class="relative group cursor-pointer max-w-sm sm:max-w-md w-full"
                        (click)="openPromoBannerLink()">

                        <!-- Banner Image -->
                        <div class="duration-300 group-hover:scale-[1.02]">
                            <img [src]="promoBannerUrl" [alt]="promoBanner?.title || 'Voucher Diskon Promo'"
                                class="w-full h-auto rounded-2xl object-cover shadow-lg">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- ========================================== -->
    <!-- 2. VOUCHER LISTING & FILTERS SECTION       -->
    <!-- ========================================== -->
    <section class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 -mt-6 relative z-20">
        <!-- Search & Filter Card -->
        <div class="bg-white rounded-2xl sm:rounded-3xl shadow-lg border border-gray-100 p-4 sm:p-6 mb-8">
            <div class="flex flex-col md:flex-row items-center justify-between gap-4">
                <!-- Search Box -->
                <div class="relative w-full md:w-80">
                    <div class="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none text-gray-400">
                        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                        </svg>
                    </div>
                    <input type="text" [(ngModel)]="searchQuery" placeholder="Cari kode atau nama voucher..."
                        class="w-full pl-10 pr-4 py-2.5 bg-gray-50 hover:bg-gray-100/80 focus:bg-white text-gray-800 placeholder-gray-400 rounded-xl border border-gray-200 focus:border-emerald-500 focus:ring-2 focus:ring-emerald-200 outline-none transition text-sm">
                </div>

                <!-- Tabs (Shopee Style) -->
                <div
                    class="flex items-center gap-1.5 sm:gap-2 overflow-x-auto w-full md:w-auto pb-1 md:pb-0 scrollbar-hide">
                    <button (click)="selectedTab = 'all'"
                        [ngClass]="selectedTab === 'all' ? 'bg-emerald-600 text-white shadow-md' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'"
                        class="px-4 py-2 rounded-xl text-xs sm:text-sm font-bold whitespace-nowrap transition cursor-pointer">
                        Semua Voucher
                    </button>
                    <button (click)="selectedTab = 'percentage'"
                        [ngClass]="selectedTab === 'percentage' ? 'bg-emerald-600 text-white shadow-md' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'"
                        class="px-4 py-2 rounded-xl text-xs sm:text-sm font-bold whitespace-nowrap transition cursor-pointer">
                        Diskon %
                    </button>
                    <button (click)="selectedTab = 'fixed'"
                        [ngClass]="selectedTab === 'fixed' ? 'bg-emerald-600 text-white shadow-md' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'"
                        class="px-4 py-2 rounded-xl text-xs sm:text-sm font-bold whitespace-nowrap transition cursor-pointer">
                        Potongan Tetap
                    </button>
                    <button (click)="selectedTab = 'claimed'"
                        [ngClass]="selectedTab === 'claimed' ? 'bg-emerald-600 text-white shadow-md' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'"
                        class="px-4 py-2 rounded-xl text-xs sm:text-sm font-bold whitespace-nowrap transition cursor-pointer flex items-center gap-1.5">
                        <span>Sudah Diklaim</span>
                        <span *ngIf="getClaimedVoucherCodes().length > 0"
                            class="w-5 h-5 rounded-full bg-emerald-100 text-emerald-800 text-[10px] flex items-center justify-center font-extrabold">
                            {{ getClaimedVoucherCodes().length }}
                        </span>
                    </button>
                </div>
            </div>
        </div>

        <!-- Loading State -->
        <div *ngIf="isLoading" class="py-16 text-center space-y-4">
            <div class="w-12 h-12 border-4 border-emerald-500 border-t-transparent rounded-full animate-spin mx-auto">
            </div>
            <p class="text-sm font-medium text-gray-500">Memuat voucher resmi dari server Visidea...</p>
        </div>

        <!-- Voucher Grid -->
        <div *ngIf="!isLoading && filteredVouchers.length > 0" class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div *ngFor="let voucher of filteredVouchers"
                class="voucher-ticket overflow-hidden flex flex-col justify-between relative group">

                <!-- Ticket Left and Right Notches -->
                <div class="ticket-notch-top left-[32%] md:left-[30%] hidden sm:block"></div>
                <div class="ticket-notch-bottom left-[32%] md:left-[30%] hidden sm:block"></div>

                <!-- Main Ticket Body -->
                <div class="flex flex-col sm:flex-row items-stretch">
                    <!-- Left Column: Value & Discount Badge (Shopee Style) -->
                    <div
                        class="sm:w-3/10 bg-gradient-to-br from-emerald-600 to-teal-700 text-white p-5 sm:p-6 flex flex-col justify-between items-center text-center ticket-perforation relative overflow-hidden">
                        <!-- Ambient background circle inside ticket -->
                        <div
                            class="absolute -top-10 -left-10 w-24 h-24 bg-white/10 rounded-full blur-lg pointer-events-none">
                        </div>

                        <!-- Top Tag -->
                        <span
                            class="inline-block px-2.5 py-0.5 rounded-full bg-white/20 text-[10px] font-extrabold tracking-wider uppercase backdrop-blur-sm">
                            {{ voucher.type === 'percentage' ? 'VOUCHER %' : 'POTONGAN' }}
                        </span>

                        <!-- Main Big Discount Text -->
                        <div class="my-3">
                            <div class="text-2xl sm:text-3xl font-extrabold tracking-tight text-white drop-shadow-sm">
                                {{ voucher.discountLabel }}
                            </div>
                            <div class="text-[11px] text-emerald-100 font-medium mt-1">
                                {{ voucher.minPurchaseFormatted }}
                            </div>
                        </div>

                        <!-- Badge if Claimed -->
                        <div *ngIf="voucher.isClaimed"
                            class="inline-flex items-center gap-1 bg-emerald-400 text-[#024D3D] px-2.5 py-0.5 rounded-full text-[10px] font-extrabold shadow-sm">
                            <span>✓</span> <span>DIKLAIM</span>
                        </div>
                        <div *ngIf="!voucher.isClaimed" class="text-[10px] text-emerald-200">
                            Kuota Terbatas
                        </div>
                    </div>

                    <!-- Right Column: Details & Actions -->
                    <div class="sm:w-7/10 p-5 sm:p-6 flex flex-col justify-between bg-white flex-1 space-y-4">
                        <!-- Top Info -->
                        <div>
                            <div class="flex items-start justify-between gap-2">
                                <div>
                                    <h3
                                        class="text-base sm:text-lg font-bold text-gray-900 group-hover:text-emerald-700 transition leading-snug">
                                        {{ voucher.name }}
                                    </h3>
                                    <p class="text-xs text-gray-500 mt-1 leading-relaxed line-clamp-2">
                                        {{ voucher.description }}
                                    </p>
                                </div>
                            </div>

                            <!-- Voucher Code Badge with Copy Button -->
                            <div
                                class="mt-3 inline-flex items-center gap-2 bg-gray-50 border border-gray-200 rounded-xl px-3 py-1.5">
                                <span class="font-mono font-bold text-xs sm:text-sm text-[#102B51] tracking-wider">
                                    {{ voucher.code }}
                                </span>
                                <button (click)="copyCode(voucher.code, $event)"
                                    class="text-xs font-bold text-emerald-600 hover:text-emerald-800 hover:underline cursor-pointer flex items-center gap-1">
                                    <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z">
                                        </path>
                                    </svg>
                                    <span>{{ copiedToastCode === voucher.code ? 'Tersalin!' : 'Salin' }}</span>
                                </button>
                            </div>
                        </div>

                        <!-- Middle Meta: Validity & Quota -->
                        <div
                            class="text-xs text-gray-400 flex items-center justify-between pt-1 border-t border-gray-100">
                            <span class="flex items-center gap-1 text-gray-500">
                                <span>📅</span> <span>{{ voucher.validUntilFormatted }}</span>
                            </span>
                            <button (click)="toggleTerms(voucher, $event)"
                                class="text-emerald-600 hover:text-emerald-800 text-xs font-semibold hover:underline cursor-pointer">
                                {{ voucher.showTerms ? 'Tutup S&K ▲' : 'S&K ▼' }}
                            </button>
                        </div>

                        <!-- Expandable Terms & Conditions -->
                        <div *ngIf="voucher.showTerms"
                            class="bg-gray-50 rounded-xl p-3 text-xs text-gray-600 space-y-1.5 border border-gray-200/80 animate-fade-in">
                            <div class="font-bold text-gray-800">Syarat & Ketentuan:</div>
                            <div>• Minimal Belanja: <b>{{ voucher.minPurchaseFormatted }}</b></div>
                            <div>• Maksimal Diskon: <b>{{ voucher.maxDiscountFormatted }}</b></div>
                            <div>• Batas Pemakaian: <b>{{ voucher.max_usage_per_user || 1 }}x per pengguna</b></div>
                            <div>• Berlaku untuk: <b>Semua Layanan Visidea (Photobooth, Undangan Digital, Guestbook,
                                    dll)</b></div>
                        </div>

                        <!-- Action Buttons (Klaim & Pakai) -->
                        <div class="pt-2 flex items-center gap-2.5">
                            <!-- Klaim Button -->
                            <button *ngIf="!voucher.isClaimed" (click)="openClaimModal(voucher, $event)"
                                class="flex-1 py-2.5 px-4 rounded-xl bg-gradient-to-r from-emerald-600 to-teal-700 hover:from-emerald-700 hover:to-teal-800 text-white font-bold text-xs sm:text-sm shadow-md hover:shadow-lg transition-all flex items-center justify-center gap-1.5 cursor-pointer">
                                <span>Klaim Voucher</span>
                            </button>

                            <!-- Sudah Diklaim Button -->
                            <button *ngIf="voucher.isClaimed" (click)="useVoucher(voucher.code, $event)"
                                class="flex-1 py-2.5 px-4 rounded-xl bg-emerald-50 text-emerald-800 border border-emerald-300 font-bold text-xs sm:text-sm transition-all flex items-center justify-center gap-1.5 cursor-pointer hover:bg-emerald-100">
                                <span>✓ Sudah Diklaim (Pakai)</span>
                            </button>

                            <!-- Test / Hitung Diskon -->
                            <button (click)="fillCalculator(voucher)" title="Hitung simulasi potongan harga"
                                class="py-2.5 px-3.5 rounded-xl bg-gray-100 hover:bg-gray-200 text-gray-700 font-semibold text-xs transition cursor-pointer flex items-center gap-1">
                                <span>Cek</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Empty State -->
        <div *ngIf="!isLoading && filteredVouchers.length === 0"
            class="bg-white rounded-3xl p-12 text-center shadow-sm border border-gray-100 space-y-4">
            <div
                class="w-16 h-16 rounded-full bg-gray-100 text-gray-400 flex items-center justify-center mx-auto text-2xl">
                🎟️
            </div>
            <h3 class="text-lg font-bold text-gray-800">Tidak ada voucher yang sesuai</h3>
            <p class="text-gray-500 text-sm max-w-md mx-auto">
                Silakan ganti kata kunci pencarian atau pilih tab kategori voucher lainnya di atas.
            </p>
            <button (click)="selectedTab = 'all'; searchQuery = ''"
                class="px-6 py-2.5 rounded-full bg-emerald-600 hover:bg-emerald-700 text-white text-sm font-bold shadow-md transition cursor-pointer">
                Tampilkan Semua Voucher
            </button>
        </div>
    </section>

    <!-- ========================================== -->
    <!-- 3. SIMULATOR / VALIDATE CALCULATOR SECTION -->
    <!-- ========================================== -->
    <section id="voucher-calculator-section" class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-14">
        <div
            class="bg-gradient-to-br from-[#102B51] via-[#163564] to-[#0A1D36] text-white rounded-3xl p-6 sm:p-10 shadow-xl border border-white/10 relative overflow-hidden">
            <!-- Decorative circle -->
            <div
                class="absolute -bottom-20 -right-20 w-80 h-80 bg-emerald-500/20 rounded-full blur-3xl pointer-events-none">
            </div>

            <div class="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center relative z-10">
                <!-- Left: Info & Instructions -->
                <div class="lg:col-span-6 space-y-4">
                    <h2 class="text-2xl sm:text-3xl font-extrabold text-white leading-tight">
                        Cek Potongan & Total Bayar Voucher Anda
                    </h2>
                    <p class="text-gray-300 text-sm leading-relaxed">
                        Masukkan kode voucher beserta perkiraan nominal transaksi untuk memeriksa potongan harga
                        otomatis yang akan Anda dapatkan.
                    </p>
                </div>

                <!-- Right: Calculator Form Card -->
                <div class="lg:col-span-6 bg-white text-gray-800 rounded-2xl p-5 sm:p-7 shadow-2xl space-y-4">
                    <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <!-- Code Input -->
                        <div>
                            <label class="block text-xs font-bold text-gray-700 uppercase tracking-wider mb-1">
                                Kode Voucher *
                            </label>
                            <input type="text" [(ngModel)]="calculatorCode" placeholder="Contoh: WELCOME10"
                                class="w-full px-4 py-2.5 bg-gray-50 border border-gray-200 rounded-xl text-sm font-mono font-bold focus:bg-white focus:border-emerald-500 focus:ring-2 focus:ring-emerald-200 outline-none uppercase transition">
                        </div>

                        <!-- Email Input -->
                        <div>
                            <label class="block text-xs font-bold text-gray-700 uppercase tracking-wider mb-1">
                                Email Pengguna *
                            </label>
                            <input type="email" [(ngModel)]="calculatorEmail" placeholder="email@anda.com"
                                class="w-full px-4 py-2.5 bg-gray-50 border border-gray-200 rounded-xl text-sm focus:bg-white focus:border-emerald-500 focus:ring-2 focus:ring-emerald-200 outline-none transition">
                        </div>
                    </div>

                    <!-- Nominal Transaksi Input -->
                    <div>
                        <label class="block text-xs font-bold text-gray-700 uppercase tracking-wider mb-1">
                            Nominal Transaksi (Rp)
                        </label>
                        <input type="number" [(ngModel)]="calculatorPrice" placeholder="150000"
                            class="w-full px-4 py-2.5 bg-gray-50 border border-gray-200 rounded-xl text-sm focus:bg-white focus:border-emerald-500 focus:ring-2 focus:ring-emerald-200 outline-none transition">
                    </div>

                    <!-- Submit Calculate Button -->
                    <button (click)="validateVoucher()" [disabled]="isValidating"
                        class="w-full py-3 rounded-xl bg-emerald-600 hover:bg-emerald-700 text-white font-bold text-sm shadow-md hover:shadow-lg transition-all flex items-center justify-center gap-2 cursor-pointer disabled:opacity-50">
                        <span *ngIf="!isValidating">Hitung Diskon Otomatis</span>
                        <span *ngIf="isValidating">Memeriksa Voucher...</span>
                    </button>

                    <!-- Validation Result Display -->
                    <div *ngIf="validationResult"
                        class="bg-emerald-50 border border-emerald-200 rounded-xl p-4 space-y-2 animate-fade-in text-sm">
                        <div
                            class="flex items-center justify-between text-emerald-900 font-bold border-b border-emerald-200 pb-2">
                            <span>Voucher Valid: {{ validationResult.voucher?.code }}</span>
                            <span class="text-xs bg-emerald-600 text-white px-2 py-0.5 rounded-full">Aktif</span>
                        </div>
                        <div class="flex justify-between text-gray-600 text-xs sm:text-sm">
                            <span>Harga Awal:</span>
                            <span class="font-semibold">Rp {{ formatNumber(calculatorPrice) }}</span>
                        </div>
                        <div class="flex justify-between text-emerald-700 text-xs sm:text-sm font-bold">
                            <span>Potongan Diskon:</span>
                            <span>- Rp {{ formatNumber(validationResult.discount_amount) }}</span>
                        </div>
                        <div
                            class="flex justify-between text-gray-900 text-base font-extrabold border-t border-emerald-200 pt-2">
                            <span>Total Bayar:</span>
                            <span class="text-emerald-700">Rp {{ formatNumber(validationResult.final_price) }}</span>
                        </div>
                        <div class="pt-2">
                            <button (click)="useVoucher(validationResult.voucher?.code)"
                                class="w-full py-2 bg-emerald-600 hover:bg-emerald-700 text-white font-bold text-xs rounded-lg shadow transition cursor-pointer">
                                Gunakan Kode Ini di Pemesanan →
                            </button>
                        </div>
                    </div>

                    <!-- Validation Error Display -->
                    <div *ngIf="validationError"
                        class="bg-red-50 border border-red-200 text-red-700 rounded-xl p-3.5 text-xs sm:text-sm flex items-start gap-2 animate-fade-in">
                        <span class="font-bold text-base leading-none">⚠️</span>
                        <span>{{ validationError }}</span>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- ========================================== -->
    <!-- 4. CARA MENGGUNAKAN VOUCHER (3 STEPS)      -->
    <!-- ========================================== -->
    <section class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-14">
        <div class="text-center max-w-2xl mx-auto mb-8 space-y-1">
            <span class="text-xs font-bold text-emerald-600 uppercase tracking-wider">Panduan Mudah</span>
            <h3 class="text-xl sm:text-2xl font-extrabold text-gray-900">Cara Menggunakan Voucher Visidea</h3>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
            <!-- Step 1 -->
            <div class="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 text-center space-y-3">
                <div
                    class="w-12 h-12 rounded-2xl bg-emerald-100 text-emerald-700 text-xl font-black flex items-center justify-center mx-auto">
                    1
                </div>
                <h4 class="text-base font-bold text-gray-900">Klaim / Salin Kode</h4>
                <p class="text-xs sm:text-sm text-gray-500 leading-relaxed">
                    Pilih voucher yang sesuai kebutuhan acara Anda, klik tombol <b>Klaim Voucher</b> atau <b>Salin
                        Kode</b>.
                </p>
            </div>

            <!-- Step 2 -->
            <div class="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 text-center space-y-3">
                <div
                    class="w-12 h-12 rounded-2xl bg-teal-100 text-teal-700 text-xl font-black flex items-center justify-center mx-auto">
                    2
                </div>
                <h4 class="text-base font-bold text-gray-900">Pilih Paket Layanan</h4>
                <p class="text-xs sm:text-sm text-gray-500 leading-relaxed">
                    Buka halaman <b>Paket Bundling</b>, <b>Undangan Digital</b>, atau <b>Photobooth</b>, lalu pilih tema
                    & opsi favorit.
                </p>
            </div>

            <!-- Step 3 -->
            <div class="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 text-center space-y-3">
                <div
                    class="w-12 h-12 rounded-2xl bg-amber-100 text-amber-700 text-xl font-black flex items-center justify-center mx-auto">
                    3
                </div>
                <h4 class="text-base font-bold text-gray-900">Masukkan Kode di Checkout</h4>
                <p class="text-xs sm:text-sm text-gray-500 leading-relaxed">
                    Tempel kode voucher pada kolom promo saat checkout untuk mendapatkan potongan harga instan.
                </p>
            </div>
        </div>
    </section>
</div>

<!-- ========================================== -->
<!-- 5. CLAIM VOUCHER MODAL (Email Prompt)      -->
<!-- ========================================== -->
<div *ngIf="isClaimModalOpen && selectedVoucherForClaim"
    class="fixed inset-0 z-[100] flex items-center justify-center p-4 overflow-y-auto">
    <!-- Backdrop -->
    <div (click)="closeClaimModal()" class="fixed inset-0 bg-black/60 backdrop-blur-sm transition-opacity"></div>

    <!-- Modal Content -->
    <div
        class="relative bg-white rounded-3xl max-w-md w-full p-6 sm:p-8 shadow-2xl z-10 border border-gray-100 animate-scale-in">
        <!-- Close Button -->
        <button (click)="closeClaimModal()"
            class="absolute top-4 right-4 w-8 h-8 rounded-full bg-gray-100 hover:bg-gray-200 text-gray-600 flex items-center justify-center transition cursor-pointer">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
        </button>

        <div class="space-y-5 text-center">
            <!-- Icon -->
            <div
                class="w-16 h-16 rounded-2xl bg-emerald-100 text-emerald-600 flex items-center justify-center mx-auto text-3xl shadow-inner">
                🎟️
            </div>

            <!-- Title & Subtitle -->
            <div class="space-y-1">
                <h3 class="text-xl font-extrabold text-[#102B51]">
                    Klaim Voucher {{ selectedVoucherForClaim.code }}
                </h3>
                <p class="text-xs sm:text-sm text-gray-500">
                    Masukkan email aktif Anda untuk mengklaim dan menyimpan promo <b>{{ selectedVoucherForClaim.name
                        }}</b>.
                </p>
            </div>

            <!-- Email Input -->
            <form (ngSubmit)="submitClaimVoucher()" class="space-y-4 text-left">
                <div>
                    <label class="block text-xs font-bold text-gray-700 uppercase tracking-wider mb-1">
                        Alamat Email Anda *
                    </label>
                    <input type="email" [(ngModel)]="claimEmail" name="claimEmail" required placeholder="nama@email.com"
                        class="w-full px-4 py-2.5 bg-gray-50 border border-gray-200 rounded-xl text-sm focus:bg-white focus:border-emerald-500 focus:ring-2 focus:ring-emerald-200 outline-none transition">
                </div>

                <div class="pt-2 flex items-center gap-3">
                    <button type="button" (click)="closeClaimModal()"
                        class="flex-1 py-2.5 rounded-xl border border-gray-300 text-gray-700 font-semibold text-sm hover:bg-gray-50 transition cursor-pointer text-center">
                        Batal
                    </button>
                    <button type="submit" [disabled]="isClaiming"
                        class="flex-1 py-2.5 rounded-xl bg-emerald-600 hover:bg-emerald-700 text-white font-bold text-sm shadow-md hover:shadow-lg transition flex items-center justify-center gap-2 cursor-pointer disabled:opacity-50 text-center">
                        <span *ngIf="!isClaiming">Klaim Sekarang</span>
                        <span *ngIf="isClaiming">Memproses...</span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>